import React from "react";
import { Download } from "lucide-react";
import { LEVELS } from "@/data/ambassadorProgramme";

const svgFor = (a, level) => {
  const color = LEVELS.find((l) => l.name === level)?.color || "#B8892B";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400">
<circle cx="200" cy="200" r="190" fill="#14213D"/><circle cx="200" cy="200" r="172" fill="none" stroke="#B8892B" stroke-width="4"/>
<circle cx="200" cy="200" r="160" fill="none" stroke="${color}" stroke-width="2" stroke-dasharray="4 6"/>
<text x="200" y="120" text-anchor="middle" font-family="Georgia,serif" font-size="22" fill="#B8892B" letter-spacing="4">CONVERGED SECURITY</text>
<text x="200" y="146" text-anchor="middle" font-family="Georgia,serif" font-size="22" fill="#B8892B" letter-spacing="4">INSTITUTE</text>
<text x="200" y="215" text-anchor="middle" font-family="Georgia,serif" font-size="76" font-weight="bold" fill="#FBF8F1">CSI</text>
<text x="200" y="262" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="26" font-weight="bold" fill="#FBF8F1" letter-spacing="6">AMBASSADOR</text>
<text x="200" y="300" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="15" fill="#B8892B">${a.ambassador_id || ""} · ${a.code || ""}</text>
${level && level !== "Member" ? `<rect x="140" y="318" width="120" height="28" rx="14" fill="${color}"/><text x="200" y="337" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="14" font-weight="bold" fill="#fff" letter-spacing="2">${level.toUpperCase()}</text>` : ""}
</svg>`;
};

export const AmbassadorBadge = ({ ambassador, level }) => {
  const svg = svgFor(ambassador, level);
  const download = () => {
    const img = new Image();
    img.onload = () => {
      const c = Object.assign(document.createElement("canvas"), { width: 800, height: 800 });
      c.getContext("2d").drawImage(img, 0, 0, 800, 800);
      Object.assign(document.createElement("a"), { href: c.toDataURL("image/png"), download: `CSI-Ambassador-Badge-${ambassador.code}.png` }).click();
    };
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  };
  return (
    <div className="flex flex-col items-center gap-3" data-testid="ambassador-badge">
      <img src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`} alt="CSI Ambassador digital badge" className="w-40 h-40"/>
      <button type="button" onClick={download} className="chip text-xs inline-flex items-center gap-1" data-testid="ambassador-badge-download"><Download size={12}/> Download badge (PNG)</button>
    </div>
  );
};
